import React from "react";

interface ChatTagsProps {
  tags: string[];
}

export default function Tags({ tags }: ChatTagsProps) {
  if (!tags || tags.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {tags.map((tag, index) => (
        <span
          key={index}
          className="px-2 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded-full"
        >
          {tag}
        </span>
      ))}
    </div>
  );
}
